import {Alert, Button, Card, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Table, TableCell, TableRow, Typography} from "@mui/material";
import Loading from "../../components/Common/Loading";
import {useDeleteChatMessageCMMutation, useGetChatCMQuery} from "../../core/api/clockmaker-clans-api";
import {format} from "date-fns";
import {useState} from "react";


const ClanChat = (props) => {

    const [messageToDelete, setMessageToDelete] = useState(null);
    const [deleteError, setDeleteError] = useState(false);
    const [deleteChatMessage, {isLoading: isDeleting}] = useDeleteChatMessageCMMutation();

    const {
        data,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetChatCMQuery(props.userId)

    const closeDeleteDialog = () => {
        setMessageToDelete(null);
        setDeleteError(false);
    };

    const confirmDelete = async () => {
        if (!messageToDelete) return;
        setDeleteError(false);
        try {
            await deleteChatMessage({
                community: messageToDelete.clanId,
                messageId: messageToDelete.id,
            }).unwrap();
            closeDeleteDialog();
        } catch {
            setDeleteError(true);
        }
    };


    return (
        <>
        <Loading
            isLoading={isLoading}
            isError={isError}
            error={error}
            isSuccess={isSuccess}
        >
            {data!=undefined && data.hasOwnProperty('response') &&
                <Grid container spacing={2}>

                    <Grid size={12}>
                        <Card>
                            <CardContent>

                                <Typography sx={{fontSize: 16}}>
                                    Chat
                                </Typography>

                            </CardContent>
                            <Table>
                                <TableRow>
                                    <TableCell>userID</TableCell>
                                    <TableCell>updatedAt</TableCell>
                                    <TableCell>Custom Data</TableCell>
                                    <TableCell>Deleted</TableCell>
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                                {data.response.history.filter(item => item.type=='TEXT').map(item => (
                                    <TableRow key={item.id}>
                                        <TableCell>{item.userId}</TableCell>
                                        <TableCell>
                                            {format(item.updatedAt, "dd.MM.yyyy HH:mm:ss")}
                                        </TableCell>
                                        <TableCell>
                                            {item.customData.text}
                                        </TableCell>
                                        <TableCell>
                                            {item.deleted==false?'':'deleted'}
                                        </TableCell>
                                        <TableCell>
                                            <Button
                                                color="error"
                                                size="small"
                                                disabled={item.deleted || isDeleting}
                                                onClick={() => setMessageToDelete(item)}
                                            >
                                                Delete
                                            </Button>
                                        </TableCell>
                                    </TableRow>
                                ))
                                }
                            </Table>
                        </Card>
                    </Grid>
                </Grid>
            }
        </Loading>
        <Dialog open={messageToDelete !== null} onClose={isDeleting ? undefined : closeDeleteDialog}>
            <DialogTitle>Delete chat message?</DialogTitle>
            <DialogContent>
                <Typography>{messageToDelete?.customData?.text}</Typography>
                {deleteError && <Alert severity="error" sx={{mt: 2}}>Failed to delete the message. Please try again.</Alert>}
            </DialogContent>
            <DialogActions>
                <Button onClick={closeDeleteDialog} disabled={isDeleting}>Cancel</Button>
                <Button onClick={confirmDelete} color="error" disabled={isDeleting}>Delete</Button>
            </DialogActions>
        </Dialog>
        </>
    )
}

export default ClanChat
